import { render } from "./FoodOptionLoader.vue?vue&type=template&id=2ece780c"
import script from "./FoodOptionLoader.vue?vue&type=script&lang=js"
export * from "./FoodOptionLoader.vue?vue&type=script&lang=js"

import "./FoodOptionLoader.vue?vue&type=style&index=0&id=2ece780c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__